import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from 'react-select';
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class VendorWorkOrderAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendors: [],
      customers: [],
      itemId: '',
      isPoSelected: false,
      projects: [],
      purchaseOrders: [],
      purchaseOrderId: "",
      items: [],
      billingAddressId: "",
      dispatchAddressId: "",
      billingAddresses: [],
      dispatchAddresses: [],
      customersDispatchAddress: [],
      customersBillingAddress: [],
      woNumber: "",
      poItems: [
        {
          serialNumber: 1,
          itemId: "",
          hsnCode: "",
          uom: "",
          quantity: "",
          price: "",
          taxableValue: '',
          gstValue: '',
          totalValue: '',
          askedQuantity: '',
          isNewRow: false
        },
      ],
      woDate: "",
      vendorId: "",
      id: "",
      status: "",
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: "",
      errors: {},
      isEdit: false,
      poId: null,
      woItems: [],
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    this.fetchCustomers();
    this.fetchVendors();
    await this.fetchItems();
    const poId = this.props.match?.params?.id;
    if (poId) {
      this.setState({ isEdit: true, poId });
      // await this.fetchPurchaseOrder(poId);
      await this.fetchVendorWorkOrder(poId);

      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    } else {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  }


  handlePoItemChange = (index, field, value) => {
    const poItems = [...this.state.poItems];
    const item = { ...poItems[index] };
    const isNumberField = ["quantity", "price", "askedQuantity"].includes(field);
    // item[field] = isNumberField ? parseFloat(value) || 0 : value;
    item[field] = isNumberField
      ? value === "" ? "" : parseFloat(value)
      : value;

    // Update HSN and UOM on itemId change only
    if (field === "itemId") {
      const selectedItem = this.state.items.find((i) => i.itemid === parseInt(value));
      if (selectedItem) {
        console.log("selectedItem", selectedItem)
        item.hsnCode = selectedItem.hsnCode || "";
        item.uom = selectedItem.uomData?.name || selectedItem.uom || "";
        item.quantity = selectedItem.quantity || ""
      } else {
        item.hsnCode = "";
        item.uom = "";
        item.quantity = ""
      }

      // Do NOT trigger recalculation here
    }

    // Recalculate values ONLY when price or askedQuantity changes
    if (field === "price" || field === "askedQuantity") {
      const quantity = parseFloat(item.askedQuantity) || 0;
      const price = parseFloat(item.price) || 0;

      item.taxableValue = +(quantity * price).toFixed(2);
      item.gstValue = +(item.taxableValue * 0.18).toFixed(2);
      item.totalValue = +(item.taxableValue + item.gstValue).toFixed(2);
    }

    poItems[index] = item;
    this.setState({ poItems });
  };

  fetchCustomersBillingAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/b`);
      this.setState({ customersBillingAddress: res.data });
    } catch (error) {
      console.error("Error fetching billing address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchCustomersDispatchAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/d`);
      this.setState({ customersDispatchAddress: res.data });
    } catch (error) {
      console.error("Error fetching dispatch address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  removeRow = (index) => {
    const poItems = [...this.state.poItems];
    poItems.splice(index, 1);
    // Recalculate serial numbers
    poItems.forEach((item, idx) => {
      item.serialNumber = idx + 1;
    });
    this.setState({ poItems });
  };

  fetchAddresses = async (customerId) => {
    try {
      const res = await axios.get(`/address?customerId=${customerId}`);
      const billingAddresses = res.data.filter((a) => a.type === "billing");
      const dispatchAddresses = res.data.filter((a) => a.type === "dispatch");

      this.setState({
        billingAddresses,
        dispatchAddresses,
      });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchCustomers = () => {
    axios
      .get("/customer")
      .then((res) => {
        this.setState({ customers: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchVendors = () => {
    axios
      .get("/vendor")
      .then((res) => {
        console.log("vendor lsit ", res.data)
        this.setState({ vendors: res.data });
      })
      .catch(() => { });
  };

  fetchItems = async () => {
    try {
      const res = await axios.get("/items");
      // console.log("res.data--riya", res.data)
      this.setState({ items: res.data });
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchPurchaseOrder = async (id) => {
    // this.setState({ loading: true });
    try {
      const res = await axios.get(`/purchaseOrders/${id}`);
      const po = res.data;
      // Set form data from PO
      this.setState({
        poNumber: po.poNumber,
        poDate: po.poDate,
        customerId: po.customerId,
        projectId: po.projectId,
        billingAddressId: po.billingAddressId,
        dispatchAddressId: po.dispatchAddressId,
        status: po.status,
        poItems: po.items.map((item) => ({
          serialNumber: item.serialNumber,
          itemId: item.itemId,
          hsnCode: item.hsnCode,
          uom: item?.uomData?.name || item.uom,
          quantity: item.quantity,
          price: item.price,
          taxableValue: item.taxableValue,
          askedQuantity: item.askedQuantity,
          gstValue: item.gstValue,
          totalValue: item.totalValue,
          // pendingQuantity: item.pendingQuantity,
        })),
      });
      // Wait for all dependent data to finish
      await Promise.all([
        this.fetchProjects(po.customerId),
        this.fetchItems(),
        this.fetchCustomersBillingAddress(po.customerId),
        this.fetchCustomersDispatchAddress(po.customerId),
      ]);
      this.setState({ showLoading: false })
    } catch (error) {
      console.error("Error fetching PO:", error);
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  };


  fetchProjects = (customerId) => {
    axios
      .get(`/project/customer/${customerId}`)
      .then((res) => {
        this.setState({ projects: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        purchaseOrderId: "",
        projects: [],
        purchaseOrders: [],
        poItems: [],
        billingAddressId: "",
        dispatchAddressId: "",
        billingAddresses: [],
        dispatchAddresses: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
          this.fetchCustomersBillingAddress(customerId);
          this.fetchCustomersDispatchAddress(customerId);
        }
      }
    );
  };

  // fetchVendorWorkOrder = (id) => {
  //   debugger;
  //   axios
  //     .get(`/vendorWorkOrders/${id}`)
  //     .then((res) => {
  //       const wo = res.data;
  //       console.log("wo", wo.items)
  //       this.setState({
  //         woNumber: wo.woNumber,
  //         woDate: wo.woDate,
  //         id: wo.vendorId,
  //         status: wo.status,
  //         poItems: wo.items || [],
  //         customerId: wo.customerId,
  //         projectId: wo.projectId,
  //         dispatchAddressId: wo.dispatchAddressId,
  //         purchaseOrderId: wo.poNumber
  //       }, () => {
  //         this.fetchCustomersDispatchAddress(wo.customerId);
  //         this.fetchProjects(wo.customerId);
  //         this.fetchPurchaseOrders(wo.customerId, wo.projectId);
  //         this.fetchItems();
  //       });
  //     })
  //     .catch(() => { });
  // };

  fetchVendorWorkOrder = (id) => {
    axios
      .get(`/vendorWorkOrders/${id}`)
      .then((res) => {
        const wo = res.data;
        console.log("wo", wo.items)
        // Map wo.items to match poItems structure
        const mappedPoItems = (wo.items || []).map((item, index) => ({
          serialNumber: index + 1,
          itemName: item.item?.name,
          itemId: item.itemId,
          hsnCode: item.item?.hsnCode || '',
          uom: item.item?.uom || '',
          quantity: item.quantity,
          price: item.price,
          taxableValue: item.taxableValue,      // You can calculate this if needed
          gstValue: item.gstValue,
          totalValue: item.totalValue,
          // pendingQuantity: '',
          askedQuantity: item.askedQuantity,
          isNewRow: false
        }));

        this.setState({
          woNumber: wo.woNumber,
          woDate: wo.woDate,
          id: wo.vendorId,
          status: wo.status,
          poItems: mappedPoItems,
          customerId: wo.customerId,
          projectId: wo.projectId,
          dispatchAddressId: wo.dispatchAddressId,
          purchaseOrderId: wo.poNumber,
          isPoSelected: true
        }, () => {
          this.fetchCustomersDispatchAddress(wo.customerId);
          this.fetchProjects(wo.customerId);
          this.fetchPurchaseOrders(wo.customerId, wo.projectId);
          this.fetchItems();
        });
      })
      .catch(() => { });
  };


  handleVendorChange = (e) => {

    const id = e.target.value;
    this.setState({ id });
    // this.setState({ vendorId });
  };

  handleInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleItemChange = (index, field, value) => {
    const woItems = [...this.state.woItems];
    woItems[index][field] = value;

    // Auto calculate total value if quantity and price are present
    if (field === "quantity" || field === "price") {
      const quantity = parseFloat(woItems[index].quantity) || 0;
      const price = parseFloat(woItems[index].price) || 0;
      woItems[index].totalValue = quantity * price;
    }

    this.setState({ woItems });
  };

  addRow = () => {
    const poItems = [...this.state.poItems];
    poItems.push({
      serialNumber: poItems.length + 1,
      itemId: "",
      itemName: "",
      hsnCode: "",
      uom: "",
      askedQuantity: '',
      quantity: "",
      price: "",
      taxableValue: 0,
      gstValue: 0,
      totalValue: 0,
      // pendingQuantity: 0,
      isNewRow: true
    });
    this.setState({ poItems });
  };


  validateForm = () => {
    const errors = {};
    if (!this.state.id) errors.id = "Vendor is required";
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.dispatchAddressId) errors.dispatchAddressId = "Dispatch address is required";

    if (!this.state.purchaseOrderId) errors.purchaseOrderId = "Purchase Order is required";
    // if (!this.state.woNumber) errors.woNumber = "WO number is required";

    const woNumber = this.state.woNumber.trim();
    const woNumberRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~ ]{1,30}$/;
    if (!woNumber) {
      errors.woNumber = "WO number is required";
    } else if (!woNumberRegex.test(woNumber)) {
      errors.woNumber = "WO number must be 1 to 30 characters and can include letters, numbers, and special characters";
    }

    if (!this.state.woDate) errors.woDate = "WO date is required";
    this.state.poItems.forEach((item, index) => {
      if (
        item.askedQuantity === undefined ||
        item.askedQuantity === null ||
        item.askedQuantity === "" ||
        isNaN(item.askedQuantity)
      ) {
        errors[`askedQuantity_${index}`] = "Asked quantity is required";
      }
      // if (!item.itemId) errors[`itemId_${index}`] = "Item is required";

      if (item.price === undefined || item.price === null || item.price === '') {
        errors[`price_${index}`] = "Price is required";
      }

      if (item.quantity === undefined || item.quantity === null || item.quantity === '') {
        errors[`quantity_${index}`] = "Quantity is required";
      }

      // if (item.gstValue === undefined || item.gstValue === null || item.gstValue === '') {
      //   errors[`gstValue_${index}`] = "GST value is required";
      // }

      // if (item.totalValue === undefined || item.totalValue === null || item.totalValue === '') {
      //   errors[`totalValue_${index}`] = "Total value is required";
      // }
    });
    return errors;
  };

  onSubmit = (e) => {
    // debugger;
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, showToast: true, toastMessage: "Please fix validation errors", toastVariant: "danger", color: 'red' });
      return;
    }
    this.setState({ loading: true });
    const {
      id,
      customerId,
      projectId,
      purchaseOrderId,
      dispatchAddressId,
      woDate,
      woNumber,
      status,
      poItems,
      isEdit,
      poId,
    } = this.state;

    console.log("poItems---", poItems)
    // debugger;
    const payload = {
      vendorId: id,
      customerId,
      projectId,
      woDate,
      woNumber,
      dispatchAddressId,
      poNumber: purchaseOrderId,
      status,
      // items: woItems,
      items: poItems.map(item => ({
        // ...item,
        serialNumber: item.serialNumber,
        itemId: item.itemId,
        hsnCode: item.hsnCode,
        uom: item.uom,
        quantity: item.quantity,
        taxableValue: item.taxableValue,
        gstValue: item.gstValue,
        totalValue: item.totalValue,
        askedQuantity: item.askedQuantity,
        // pendingQuantity: item.pendingQuantity,
        price: item.price
      })),
    };
    // debugger;
    console.log("payload is : ", payload)

    const request = isEdit
      ? axios.put(`/vendorWorkOrders/${poId}`, payload)
      : axios.post("/vendorWorkOrders", payload);

    request
      .then(() => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: `Vendor Work Order ${isEdit ? "updated" : "created"} successfully!`,
          toastVariant: "success",
          color: 'green'
        });
        if (!isEdit) {
          this.setState({
            projectId: "",
            customerId: "",
            dispatchAddressId: "",
            poItems: [],
            errors: {},
          });
        }
        setTimeout(() => {
          this.setState({ loading: false })
          this.handleBack()
        }, 600)
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Vendor Work Order",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  fetchPurchaseOrders = (customerId, projectId) => {
    axios
      .get(`/purchaseOrders/${customerId}/${projectId}`)
      .then((res) => {
        this.setState({
          purchaseOrders: res.data,
          loading: false
        });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };


  fetchPoItems = (purchaseOrderId) => {
    this.setState({ loading: true });
    axios
      .get(`/purchaseOrders/${purchaseOrderId}`)
      .then((res) => {
        this.setState({
          poItems: res.data.items.map((item) => ({
            // purchaseOrderItemId: item.id,
            serialNumber: item.serialNumber,
            hsnCode: item.hsnCode,
            itemId: item.itemId,
            itemName: item?.item.name,
            totalValue: item.totalValue,
            taxableValue: item.taxableValue,
            price: item.price,
            gstValue: item.gstValue,
            askedQuantity: item.askedQuantity,
            // pendingQuantity: item.pendingQuantity,
            uom: item.uom,
            quantity: item.quantity,
            // loading: false
          })),
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };


  handlePurchaseOrderChange = (e) => {

    const purchaseOrderId = e.target.value;
    const isPoSelected = !!purchaseOrderId;
    this.setState({ purchaseOrderId, poItems: [], isPoSelected }, () => {
      if (purchaseOrderId) {
        this.fetchPoItems(purchaseOrderId);
      }
    });
  };

  handleBillingAddressChange = (e) => {
    this.setState({ billingAddressId: e.target.value });
  };

  handleDispatchAddressChange = (e) => {
    this.setState({ dispatchAddressId: e.target.value });
  };

  handleProjectChange = (e) => {
    const projectId = e.target.value;
    this.setState(
      {
        projectId,
        purchaseOrderId: "",
        purchaseOrders: [],
        poItems: [],
      },
      () => {
        if (this.state.customerId && projectId) {
          this.fetchPurchaseOrders(this.state.customerId, projectId);
        }
      }
    );
  };

  handleBack = () => {
    this.props.history.push("/vendor-work-order-list");
  }


  render() {
    const {
      customers,
      projects,
      purchaseOrders,
      billingAddressId,
      poItems,
      itemId,
      items,
      woDate,
      woNumber,
      customerId,
      dispatchAddressId,
      projectId,
      id,
      vendors,
      purchaseOrderId,
      status,
      errors,
      vendorId,
      loading,
      isEdit
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>{isEdit ? "Update" : "Add"} Vendor Work Order</b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.handleBack()}>
                    <i className="far fa-arrow-alt-circle-right"> Vendor Work Order List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body style={{ marginBottom: '40px' }}>
                <Form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formVendor">
                        <Form.Label className="required">Vendor</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={id || vendorId}
                          onChange={this.handleVendorChange}
                          isInvalid={!!errors?.id}
                        >
                          <option value="">Select Vendor</option>
                          {vendors.map((v) => (
                            <option key={v.id} value={v.id}>
                              {v.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.id}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                        // disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>

                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                        // disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPurchaseOrder">
                        <Form.Label className="required">Purchase Order</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={purchaseOrderId}
                          onChange={this.handlePurchaseOrderChange}
                          isInvalid={!!errors?.purchaseOrderId}
                        // disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Purchase Order</option>
                          {purchaseOrders.map((po) => (
                            <option key={po.id} value={po.id}>
                              {po.poNumber}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.purchaseOrderId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col md={6}>
                      <Form.Group controlId="formBillingAddress">
                        <Form.Label className="required">Billing Address</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={billingAddressId}
                          onChange={this.handleBillingAddressChange}
                          isInvalid={!!errors?.billingAddressId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Billing Address</option>
                          {this.state.customersBillingAddress.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.billingAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col md={3}>
                      <Form.Group controlId="formWoNumber">
                        <Form.Label className="required">WO Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={woNumber}
                          placeholder="Enter Work Order Number"
                          onChange={(e) => this.handleInputChange("woNumber", e.target.value)}
                          isInvalid={!!errors?.woNumber}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.woNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId="formWoDate">
                        <Form.Label className="required">WO Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={woDate}
                          onChange={(e) => this.handleInputChange("woDate", e.target.value)}
                          isInvalid={!!errors?.woDate}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.woDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formDispatchAddress">
                        <Form.Label className="required">Dispatch Address</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={dispatchAddressId}
                          onChange={this.handleDispatchAddressChange}
                          isInvalid={!!errors?.dispatchAddressId}
                        // disabled={status === "pending"}
                        >
                          <option value="">Select Dispatch Address</option>
                          {this.state.customersDispatchAddress.map((a) => (
                            // {dispatchAddresses.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.dispatchAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  {(isEdit || this.state.isPoSelected) && (
                    <>
                      <hr />
                      <h5>Items</h5>
                      {poItems.map((item, index) => (
                        <Card key={index} className="mb-3" >

                          <Card.Body>
                            <Row>
                              <Col md={2}>
                                <Form.Group controlId={`formSno${index}`}>
                                  <Form.Label>S.No</Form.Label>
                                  <Form.Control type="text" value={item.serialNumber} readOnly />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId={`formItem${index}`}>
                                  <Form.Label className="required">Item</Form.Label>
                                  {!item.isNewRow ?
                                    (
                                      <>
                                        <Form.Control type="text" value={item.itemName} readOnly />
                                      </>

                                    ) : (
                                      <>
                                        <Select
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          options={items.map((i) => ({
                                            value: i.itemid,
                                            label: i.name
                                          }))}
                                          value={
                                            items.find((i) => i.itemid === item.itemId)
                                              ? {
                                                value: item.itemId,
                                                label: items.find((i) => i.itemid === item.itemId).name
                                              }
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            this.handlePoItemChange(index, "itemId", selectedOption?.value || "")
                                          }
                                          // isInvalid={!!this.state.errors?.[`itemId_${index}`]}
                                          isDisabled={status === "pending"}
                                          placeholder="Select Item"
                                          isSearchable={true}
                                        />
                                        {errors?.[`itemId_${index}`] && (
                                          <div className="invalid-feedback d-block">
                                            {errors[`itemId_${index}`]}
                                          </div>
                                        )}
                                      </>
                                    )}

                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId={`formHsnCode${index}`}>
                                  <Form.Label>HSN Code</Form.Label>
                                  <Form.Control type="text" value={item.hsnCode} readOnly />
                                </Form.Group>
                              </Col>
                              <Col md={2}>
                                <Form.Group controlId={`formUom${index}`}>
                                  <Form.Label>UOM</Form.Label>
                                  <Form.Control type="text" value={item.uom} readOnly />
                                </Form.Group>
                              </Col>
                              <Col md={2}>
                                <Form.Group controlId={`formQuantity${index}`}>
                                  <Form.Label className="">Quantity</Form.Label>
                                  <Form.Control
                                    type="number"
                                    value={item.quantity}
                                    // placeholder="Enter quantity"
                                    onChange={(e) => this.handlePoItemChange(index, "quantity", e.target.value)}
                                    isInvalid={!!errors?.[`quantity_${index}`]}
                                    // disabled={status === "pending"}
                                    readOnly={!item.isNewRow}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={2}>
                                {/* <Form.Group controlId={`formAskedQuantity${index}`}>
                              <Form.Label className="required">Asked Quantity</Form.Label>
                              <Form.Control type="text" value={item.askedQuantity}
                                placeholder="Asked quantity"
                                isInvalid={!!errors?.askedQuantity}
                                onChange={(e) => this.handlePoItemChange(index, "askedQuantity", e.target.value)}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`askedQuantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group> */}
                                <Form.Group controlId={`formAskedQuantity${index}`}>
                                  <Form.Label className="required">Asked Quantity</Form.Label>
                                  <Form.Control
                                    type="number"
                                    placeholder="Asked quantity"
                                    value={item.askedQuantity}
                                    onChange={(e) => this.handlePoItemChange(index, "askedQuantity", e.target.value)}
                                    isInvalid={!!this.state.errors?.[`askedQuantity_${index}`]}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {this.state.errors?.[`askedQuantity_${index}`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId={`formPrice${index}`}>
                                  <Form.Label className="required">Price</Form.Label>
                                  <Form.Control
                                    type="number"
                                    value={item.price}
                                    placeholder="Enter Price"
                                    onChange={(e) => this.handlePoItemChange(index, "price", e.target.value)}
                                    isInvalid={!!errors?.[`price_${index}`]}
                                  // disabled={status === "pending"}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors?.[`price_${index}`]}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId={`formTaxableValue${index}`}>
                                  <Form.Label className="required">Taxable Value</Form.Label>
                                  <Form.Control type="number" value={item.taxableValue}
                                    // onChange={(e) => this.handlePoItemChange(index, "taxableValue", e.target.value)}
                                    // placeholder="Enter taxable value"
                                    readOnly
                                  // isInvalid={!!errors?.[`taxableValue_${index}`]}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors?.[`taxableValue_${index}`]}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md={2}>
                                <Form.Group controlId={`formGstValue${index}`}>
                                  <Form.Label className="required">GST (18%)</Form.Label>
                                  <Form.Control type="number" value={item.gstValue}
                                    readOnly
                                  // isInvalid={!!errors?.[`gstValue_${index}`]}
                                  // placeholder="Enter gst value"
                                  // onChange={(e) => this.handlePoItemChange(index, "gstValue", e.target.value)}

                                  />
                                  {/* <Form.Control.Feedback type="invalid">{errors?.[`gstValue_${index}`]}</Form.Control.Feedback> */}
                                </Form.Group>
                              </Col>
                              <Col md={2}>
                                <Form.Group controlId={`formTotalValue${index}`}>
                                  <Form.Label className="required">Total Value</Form.Label>
                                  <Form.Control type="number" value={item.totalValue}
                                    readOnly
                                  // isInvalid={!!errors?.[`totalValue_${index}`]}
                                  // placeholder="Enter total value"
                                  // onChange={(e) => this.handlePoItemChange(index, "totalValue", e.target.value)}
                                  />
                                  {/* <Form.Control.Feedback type="invalid">{errors?.[`totalValue_${index}`]}</Form.Control.Feedback> */}
                                </Form.Group>

                              </Col>
                              {/* <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Pending Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col> */}
                            </Row>
                            {status !== "pending" && (
                              <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel mt-3" onClick={() => this.removeRow(index)} >
                                Remove
                              </Button>
                            )}
                          </Card.Body>

                        </Card>
                      ))}
                      {status !== "pending" && (
                        <Button
                          variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.addRow} >
                          Add Row
                        </Button>
                      )}
                      <hr />
                    </>
                  )}

                  <div className="text-left mt-3">
                    <Button className="status-btn px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" variant='primary' type="submit" >
                      {isEdit ? "Update" : "Save"} Vendor Work Order
                    </Button>
                    <Button

                      variant='danger' className=" px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel"
                      onClick={() => this.handleBack()}
                    >
                      Cancel
                      {/* Save as Pending */}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card >
          </div >
        </CommonLoader >
      </>
    );
  }
}
